interface UserDetail {
  id: string;
  name: string;
  email: string;
  mainSuperAdminId: string;
  managerId: null | string;
  picture: null | string;
  number: null | string;
  paneltype: string;
  pseudonym: string;
  pages: string;
  commentPages: string;
  username: string;
  plans: string;
  hasTrial: string;
  verified: number;
  facebookId: string;
  endDate: string;
  subscriptionId: string;
  stripe_id: string;
  currentCount: number;
  maxCount: number;
  currentDeletedCount: number;
  stripe_subscription_status: string;
  new_plan: string;
  new_plan_status: string;
  plan_change_effective_date: string | null;
  plan_change_type: string | null;
}

export default function useActiveUserDetail() {
  const activeUserDetail = localStorage.getItem("ActiveUserdetail");
  const data: UserDetail = activeUserDetail
    ? JSON.parse(activeUserDetail)
    : null;

  return {
    agentId: data?.id,
    name: data?.name,
    email: data?.email,
    username: data?.username,
    mainSuperAdminId: Number(data?.mainSuperAdminId),
    managerId: data?.managerId,
    panelType: data?.paneltype,
    verified: data?.verified,
    facebookId: data?.facebookId,
    number: data?.number,
    picture: data?.picture,
    pages: data?.pages,
    commentPages: data?.commentPages,
    pseudonym: data?.pseudonym,
    plans: data?.plans,
    hasTrial: data?.hasTrial,
    endDate: data?.endDate,
    subscriptionId: data?.subscriptionId,
    stripeId: data?.stripe_id,
    currentCount: data?.currentCount,
    maxCount: data?.maxCount,
    currentDeletedCount: data?.currentDeletedCount,
    stripe_subscription_status: data?.stripe_subscription_status,
    new_plan: data?.new_plan,
    new_plan_status: data?.new_plan_status,
    plan_change_effective_date: data?.plan_change_effective_date,
    plan_change_type: data?.plan_change_type,
  };
}
